import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = {
  key: 0,
  class: "bg-info text-white px-3 py-1 font-weight-bold text-capitalize fixed-top-right"
}

import {
  NLoadingBarProvider,
  NMessageProvider,
  NNotificationProvider,
  NDialogProvider,
  NConfigProvider,
} from "naive-ui";

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const VUE_APP_MODE = process.env.VUE_APP_MODE;

const themeOverrides = {
  common: {
    primaryColor: "#01c906",
    warningColor: "#FFBF1A",
    errorColor: "#F94200",
    borderRadius: "8px",
  },
  Button: {
    fontWeight: "500",
  },
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_unref(NConfigProvider), { "theme-overrides": themeOverrides }, {
    default: _withCtx(() => [
      _createVNode(_unref(NLoadingBarProvider), null, {
        default: _withCtx(() => [
          _createVNode(_unref(NMessageProvider), null, {
            default: _withCtx(() => [
              _createVNode(_unref(NNotificationProvider), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(NDialogProvider), null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, [
                        (_unref(VUE_APP_MODE) === 'development')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_2, " mode: " + _toDisplayString(_unref(VUE_APP_MODE)), 1))
                          : _createCommentVNode("", true),
                        _createVNode(_component_router_view)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})